import React, {useState} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {Grid, Menu, Modal, Icon, Dropdown} from 'semantic-ui-react';

import {
  webContentManagementServices,
  communicationServices,
} from 'components/LandingPage/servicesDefinition';
import QrCodeCreateForm from 'components/QrCode/QrCodeCreateForm';
import SearchBar from 'components/Search/SearchBar/SearchBar';
import {useWindowWidth} from 'hooks/useWindowWidth';

import {sitesTypeInfo} from '../Common/sharedElements';

import styles from './PortalToolbar.module.scss';

const PortalToolbar = () => {
  const width = useWindowWidth();
  const history = useHistory();
  const currentLocation = useLocation();
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);

  return (
    <>
      <Grid columns="equal" className={styles.PortalToolbar}>
        <Grid.Column>
          <Menu secondary>
            <Menu.Item href="/">
              <Icon name="sidebar" className={styles.HamburgerMenu} />
              <h2>Web Services Portal</h2>
            </Menu.Item>
          </Menu>
        </Grid.Column>
        <Grid.Column>
          <Menu secondary widths={3} className={styles.DesktopMenu}>
            <Dropdown item text="Create">
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to="/webeos">
                  WebEOS site
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/paas">
                  PaaS project
                </Dropdown.Item>
                {/* <Dropdown.Item as={Link} to="/app-catalogue">
                  Application from a catalogue
                </Dropdown.Item> */}
                <Dropdown.Item as={Link} to="/nexus">
                  Nexus Instance
                </Dropdown.Item>
                <Dropdown.Item
                  href={communicationServices['discourse']['docsUrl']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Discourse Instance
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/gps">
                  GitLab Pages site
                </Dropdown.Item>
                <Dropdown.Item
                  href={webContentManagementServices['sharepoint']['url']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  SharePoint Online site
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/wordpress">
                  WordPress site
                </Dropdown.Item>
                <Dropdown.Item onClick={() => setShowQRCodeModal(true)}>
                  Create QR Code
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Menu.Item as={Link} to="/my-sites" name="My sites" />
            <Menu.Item as={Link} to="/short-urls" name="Short URL" />
            <Dropdown item text="Help">
              <Dropdown.Menu>
                <Dropdown.Item
                  href={sitesTypeInfo['webeos']['documentationUrl']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WebEOS
                </Dropdown.Item>
                <Dropdown.Item
                  href={sitesTypeInfo['drupal']['documentationUrl']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Drupal
                </Dropdown.Item>
                <Dropdown.Item
                  href={sitesTypeInfo['paas']['documentationUrl']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  PaaS
                </Dropdown.Item>
                <Dropdown.Item
                  href={sitesTypeInfo['app-catalogue']['documentationUrl']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  App Catalogue
                </Dropdown.Item>
                <Dropdown.Item
                  href={sitesTypeInfo['gps']['documentationUrl']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitLab Pages
                </Dropdown.Item>
                <Dropdown.Item
                  href={sitesTypeInfo['wordpress']['documentationUrl']}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WordPress
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu>
        </Grid.Column>
        <Grid.Column textAlign="right" verticalAlign="middle">
          {!currentLocation.pathname.startsWith('/search') &&
            (width < 767 ? (
              <Icon
                name="search"
                className={styles.SearchIcon}
                onClick={() => history.push('/search')}
              />
            ) : (
              <SearchBar size="small" />
            ))}
        </Grid.Column>
      </Grid>

      {showQRCodeModal && (
        <Modal open={showQRCodeModal} onClose={() => setShowQRCodeModal(false)}>
          <Modal.Header>Create a QR Code</Modal.Header>
          <Modal.Content>
            <QrCodeCreateForm />
          </Modal.Content>
        </Modal>
      )}
    </>
  );
};

export default PortalToolbar;
